import React from "react";
import { CheckIcon } from "lucide-react";
import { includedItems, solutionSteps } from "../data/landing";
import { productBrief } from "../data/productBrief";
export function SolutionSection() {
  return <section className="section" id="how-it-works" aria-labelledby="solution-heading" data-id="element-180" data-mp="3o9k86tc6172q">
      <div className="shell" data-id="element-181" data-mp="3j9o64zn13ppt">
        <div className="section-intro" data-id="element-182" data-mp="3j9fpcwnsc09c">
          <p className="eyebrow" data-id="element-183" data-mp="14kx53txytk4">HOW IT WORKS</p>
          <h2 id="solution-heading" data-id="element-184" data-mp="139uj7c8frul">
            Choose the session. <span data-id="element-185" data-mp="3t8n5frlwm905">Follow the prepared plan.</span>
          </h2>
          <p data-id="element-186" data-mp="3t851e8t02qho">The agenda, exercises, facilitator wording and feedback tools are prepared together. Here is how you put them to work.</p>
        </div>
        <ol className="steps-grid" data-id="element-187" data-mp="5usygy9grdwc">
          {solutionSteps.map((step, i) => <li key={step.title} data-id="element-188" data-mp="ksldzqf0g2aj" data-mpi={i}>
              <p className="step-number" aria-hidden="true" data-id="element-189" data-mp="ktmxmja3dx3v">
                {String(i + 1).padStart(2, "0")}
              </p>
              <h3 data-id="element-190" data-mp="fvbpqe3cxwoa">{step.title}</h3>
              <p data-id="element-191" data-mp="36am3plcfuw3f">{step.body}</p>
            </li>)}
        </ol>
        <div className="included-grid" data-id="element-192" data-mp="36cp14qfx7ri6">
          {includedItems.map(item => <div key={item.title} data-id="element-193" data-mp="3ba8n6civ18ko">
              <CheckIcon size={18} aria-hidden="true" data-id="element-194" data-mp="3fbagkcq3iqeq" />
              <div data-id="element-195" data-mp="3f9qycgkvq5ab">
                <h3 data-id="element-196" data-mp="3fdesnhy5evq3">{item.title}</h3>
                <p data-id="element-197" data-mp="3kawrugmd5wkw">{item.body}</p>
              </div>
            </div>)}
        </div>
        <p className="prep-note" data-id="element-198" data-mp="3p9q4k6tttjk0">
          You'll still read the facilitator plan and print the participant pages before each
          session. The session structure, cases and worksheets are already written for you.
        </p>
      </div>
    </section>;
}